import React from "react";
const IconArrow = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.2929 13H6.5C6.22386 13 6 12.7761 6 12.5C6 12.2239 6.22386 12 6.5 12H16.2929L14.1464 9.85355C13.9512 9.65829 13.9512 9.34171 14.1464 9.14645C14.3417 8.95118 14.6583 8.95118 14.8536 9.14645L17.8536 12.1464C17.9015 12.1944 17.9377 12.2496 17.9621 12.3086C17.9861 12.3667 17.9996 12.4303 18 12.497M17.9621 12.6914C17.9377 12.7504 17.9015 12.8056 17.8536 12.8536L14.8536 15.8536C14.6583 16.0488 14.3417 16.0488 14.1464 15.8536C13.9512 15.6583 13.9512 15.3417 14.1464 15.1464L16.2929 13M17.9621 12.6914C17.9842 12.6378 17.9967 12.5811 17.9994 12.524C17.9998 12.516 18 12.508 18 12.5",
  fill: "currentColor"
}));
var IconArrow_default = IconArrow;
export {
  IconArrow_default as default
};
